import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility,formStyles, markdown } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility'; 
import { EventManager } from '../../utilities/events';
import { ContextProvider} from '@lit/context';
import { organisationContext } from '../../utilities/context';
import { getStatus, getTier } from '../../utilities/orgUtilities';
import { decodeEntities } from '../../utilities/formsUtilities';
import { AllInConditionals } from '../Utilities/AllInConditionals';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInOrganisationManager extends AllInSessionStorage(AllInConditionals(LitElement)) {
    static properties = {

        config_organisations: { type: Object, reflect:true},
        config_user: { type: Object, reflect:true},
        config_restUrl: { type: String, reflect:true},
        config_nonce: { type: String, reflect:true},
        config_hardlinks: { type: Object, reflect:true},
        dashboard:{type:String},
        organisations: { type: Object},
        organisation: { type: Object},
        user: { type: Object, state:true },
        panel: {type: String},
        view: {type: String},
        panels: {type: Object},
        integration_panels: {type: Object},
        member_lookup_texts: {type: Object},
        support_org_language_texts: {type: Object},   
        org_events_language_texts: {type: Object},
        currentOrg: {type: String, reflect:true},
        name: { type: String },
        restUrl: { type: String },
        action: { type: String },
        nonce: { type: String },
        location: { type: Object },
        orgLoaded: { type: Boolean, state:true },
        hasLocation: { type: Boolean, state:true },
        hasZone: { type: Boolean, state:true },
        hasApproval: { type: Boolean, state:true },
        members: { type: Object, state:true },
        membersLookedUp: { type: Object, state:true },
        _hasFetchedOrgs: {type: Array, state:true},        
        _fetchingOrgsComplete: {type: Boolean, state:true},
    }

    constructor() {
        super();
        this.timeoutcount = 0;
        this._hasFetchedOrgs = [];
        this._fetchingOrgsComplete = false;
        this.groupFlag = true;
        this.supportFlag = true;
    }

    async connectedCallback() {
        super.connectedCallback();
        this.organisations = this.config_organisations;
        this.user = this.config_user;
        this.restUrl = this.config_restUrl;
        this.nonce = this.config_nonce;
        this.hardlinks = this.config_hardlinks;
        this.config_organisations = null;
        this.config_user = null;
        this.config_restUrl = null;
        this.config_nonce = null;
        this.config_hardlinks = null;
        this.initiating = true;
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-organisation-${this.name}-update`,this._handleUpdate);
        this.eventManager.listen(`allin-organisation-${this.name}-switcher`,this._handleSwitch);
        this.eventManager.listen(`allin-navigation-reset-${this.name}`,this._resetNavigation);
        this.context = {
            name:this.name,
            organisations:this.organisations,
            organisation:this.organisation,
            user:this.user,
            currentOrg:this.currentOrg,
            dashboard:this.dashboard,
            panel:this.panel,
            view:this.view,
            subview:this.subview,
            panels:this.panels,
            integration_panels:this.integration_panels,
            support_org_language_texts:this.support_org_language_texts,
            member_lookup_texts:this.member_lookup_texts , 
            org_events_language_texts:this.org_events_language_texts,
            restUrl:this.restUrl,
            action:this.action,
            nonce:this.nonce,
            hardlinks:this.hardlinks,
            provisions:[],
            zoneProvisions:[],
            eventProvisions:[],
            memberProvisions:[],
            location: this.location,
            providerConfig: {},
            providerConfigMapping: {},
            location: this.location,
            members: this.members,
            membersLookedUp: this.membersLookedUp,
        };
        this._provider = new ContextProvider(this,{context:organisationContext,initialValue:this.context});
        if(this.currentOrg){
            this._switchOrg(this.currentOrg,this.dashboard);
            if(window.localStorage.getItem(`allin-paged-form-subscriptionform-current-page-${this.currentOrg}`)){
                window.localStorage.removeItem(`allin-paged-form-subscriptionform-current-page-${this.currentOrg}`);
                window.localStorage.removeItem(`allin-paged-form-subscriptionform-${this.currentOrg}-link`);
            }
        }
        this.eventManager.initHistory({currentOrg:this.currentOrg??'',dashboard:this.dashboard??''});
        if(this.dashboard){
            this[`_show${this.dashboard.charAt(0).toUpperCase() + this.dashboard.slice(1)}`]();
        }
       
        
        this.existingFormPage = window.localStorage.getItem(`allin-paged-form-orgsetupform-current-page-${this.user.id}`);
        this.existingForm = window.localStorage.getItem(`allin-paged-form-orgsetupform-${this.user.id}`);
        if(this.existingForm){
            this.existingForm = JSON.parse(this.existingForm);
        }
        this.hasForm = this.existingFormPage&&this.existingFormPage!=='success'?true:false;
        
        cardLinks(this.shadowRoot);
        this.initiating = false;
    }

    async firstUpdated(){
        let nav = document.querySelector('allin-navigation');
        let breadcrumb = document.querySelector('allin-breadcrumb');

        await new Promise((resolve) => requestAnimationFrame(resolve));
        if(nav){
            await nav.updateComplete;
        }
        if(breadcrumb){
            await breadcrumb.updateComplete;
        }
        if(this.currentOrg){
            if(!this.panel){
                this._emitAll(false);
            }
        }
        this._setSlotLinkClasses();
        this._fetchOrganisations();
        this._loadNavigation();

    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    get _slottedLinkChildren() {
        const slot = this.shadowRoot.querySelector('slot[name="links"]');
        if(!slot) return [];
        return slot.assignedElements({flatten: true});
    }

    async updated(changedProperties){
        let changeHistory = true
        if(changedProperties.has('panel')&&this.panel){
            changeHistory = false;
        }
        //await new Promise((resolve) => requestAnimationFrame(resolve));
        if(changedProperties.has('currentOrg')||changedProperties.has('dashboard')){
            if(this.currentOrg){
                this._hasLocation();
                this._hasZone();
                this._hasApproval();
                this._isPilot();
                this._getTier();
                this._getUsers();
                this._setProfilesTypes();
                if(!this.panel){
                    this._emitAll(changeHistory);
                }
                this.orgLoaded = true;
                this._setSlotLinkClasses();
                if(window.localStorage.getItem(`allin-paged-form-subscriptionform-current-page-${this.currentOrg}`)){
                    window.localStorage.removeItem(`allin-paged-form-subscriptionform-current-page-${this.currentOrg}`);
                    window.localStorage.removeItem(`allin-paged-form-subscriptionform-${this.currentOrg}-link`);
                }
            }
            else if (this.currentOrg==''&&this.dashboard==''){
                this._emitReset();
            }
        }
        if(changedProperties.has('dashboard')){
            if(this.dashboard===''){
                this.focus();
            }
            else{
                if(!this.panel){
                    this._emitDashboard(changeHistory);
                }
            }
        }
        cardLinks(this.shadowRoot);
        this._setSlotLinkClasses();
        //REMEMBER TO CHECK COMMENTING OUT THE LINE BELOW IN CASE ANY FUTURE ISSUES WITH SCROLLLING TO THE RIGHT SECTION OF THE PAGE
        //this.scrollIntoView({behavior:'smooth',block:'start'});
    }

    render() {
        let main='';
        if(this.currentOrg){
            let org = this._getOrganisationById(this.currentOrg);

            if(!org){
                main = html`<h2>${msg(str`Organisation not found`)}</h2>`;
            }
            else if(this.dashboard=='settings'){
                main = html`
                    <allin-organisation-settings
                    ></allin-organisation-settings>
                    `;
            }
            else if(this.dashboard=='members'){
                main = html`
                <allin-organisation-members-manager></allin-organisation-members-manager>
                `;
            }
            else if(this.dashboard=='locations'){
                main = html`
                <allin-organisation-locations-manager></allin-organisation-locations-manager>
                `;
            }
            else if(this.dashboard=='events'){
                main = html`
                <allin-organisation-events-manager></allin-organisation-events-manager>
                `;
            }
            else if(this.dashboard=='subscriptions'){
                const tier = this._getTier();
                let slot;
                if(tier=='Tier1'){
                    slot = html`<slot name="subscription-banner-new"></slot>`;
                }
                else{
                    if(this.panel=='group'&& this._isAdmin() && this.groupFlag){
                        slot = html`<slot name="subscription-banner-group"></slot>`;
                    }
                    else{
                        slot = html`<slot name="subscription-banner"></slot>`;
                    }
                }
                main = html`
                <allin-organisation-subscriptions></allin-organisation-subscriptions>
                    ${slot}
                `;
            }
            else if(this.dashboard=='integrations'){
                main = html`
                    <allin-organisation-integrations-manager></allin-organisation-integrations-manager>
                `;
            }
            else if(this.dashboard=='support'&& this.supportFlag){
                main = html`
                    <allin-organisation-support-profiles-manager name=${this.name} currentOrg=${this.currentOrg} panel=${this.panel} view=${this.view}></allin-organisation-support-profiles-manager>
                `;
            }
            else{
                if(org.approvalStatus=='NewApplication'){
                    const org = this._getOrganisationById(organisation.org_id);
                    const page = org?.in_progress != null ? Math.max(0, Number(org.in_progress) - 0) : this.existingFormPage;
                    main = html`<h2>${msg(str`Your application is in progress`)}</h2>
                    <a href="${this.hardlinks.organisation_dashboard_create_organisation}?org_id=${org.org_id}&&ppage=${page}" class="button">${msg(str`Complete your application`)}</a>
                    `
                }
                else{
                    const onboarded = this._isOnboarded();
                    const tier = this._getTier();
                    let slot = html`<slot name="organisation-welcome-text" @slotchange=${this._processSlot}></slot>`;
                    let subscriptionBanner = '';
                    if(tier!=='Tier1' && this.hasCulturalProfile){
                        slot = html`<slot name="organisation-welcome-plus-text" @slotchange=${this._processSlot}></slot>`;
                    }
                    else if(this.hasSupportProfile){
                        slot = html`<slot name="organisation-welcome-support-text" @slotchange=${this._processSlot}></slot>`;
                    }
                    let notifications = ''
                    let locationsEl = '';
                    let supportEl = '';
                    let subscribeEl = '';
                    if(this.hasApproval){
                        if(tier!=='Tier1' && this.hasCulturalProfile){
                            slot= html`<slot name="organisation-post-approval-plus-text" @slotchange=${this._processSlot}></slot>`;
                        }
                        else if(this.hasCulturalProfile){
                            slot = html`<slot name="organisation-post-approval-text" @slotchange=${this._processSlot}></slot>`;
                        }
                        else if(this.hasSupportProfile){
                            slot = html`<slot name="organisation-post-approval-support-text" @slotchange=${this._processSlot}></slot>`;
                        }
                        if(tier==='Tier1' && this.hasCulturalProfile){
                            subscribeEl = html`
                                <div class="bg inner-padding">
                                <h4><slot name="subscription-cta-new-title"></slot></h4>
                                <slot name="subscription-cta-new"></slot>
                                <button @click=${(e)=>{this._showSubscriptions(e)}} class="button"><slot name="subscription-cta-new-button-text"></slot></button>
                                </div>
                                `
                            ;
                        }
                        else{
                            if(org.subscriptionEndDate&&new Date(org.subscriptionEndDate) < new Date()){
                                subscribeEl = html`
                                    <div class="bg inner-padding">
                                    <h4><slot name="subscription-cta-renew-title"></slot></h4>
                                    <slot name="subscription-cta-renew"></slot>
                                    <button @click=${(e)=>{this._showSubscriptions(e)}} class="button"><slot name="subscription-cta-renew-button-text"></slot></button>
                                    </div>
                                `;
                            }
                        }
                    }
                    if(org.approvalStatus=='ChangesRequested'){
                        slot = html`<p>${getStatus(org.approvalStatus)}</p>`;
                    }
                    if(org.declineMessage){
                        let link = org.approvalStatus=='ChangesRequested'?html`<a href="javascript:void(0)" @click=${(e)=>{e.preventDefault();this.panel='account';this._showSettings()}}>${msg('Take action')}</a>`:'';
                        notifications = html`<div class="message">
                            <h4>You have 1 notification</h4>
                            <ul>
                                <li>
                                    <div><p>${org.declineMessage}</p>${link}</div>
                                </li>
                            </ul>
                        </div>`;
                    }
                    if(this.hasCulturalProfile){
                        locationsEl = html`<allin-organisation-locations currentorg=${this.currentOrg}></allin-organisation-locations>`;
                    }
                    if(this.hasSupportProfile&&this.hasApproval){
                        supportEl = html`<allin-organisation-support-profiles currentorg=${this.currentOrg}></allin-organisation-support-profiles>`;
                    }
                    let groupInvites = '';
                    if(this.user.groupInvites.length > 0 && this.groupFlag ){
                        let _groupInvites = this.user?.groupInvites?.filter((invite)=>invite.name==org.name);
                        if(_groupInvites.length > 0){
                            groupInvites  =  html`<div class="invites">
                                <h4>${msg(str`Your subscription group invites`)}</h4>
                                <ul>
                                    ${_groupInvites.map((invite)=>{
                                        let org = this.organisations.find((org)=>org.name==invite.name);
                                        if(invite.inviteStatus=='Accepted'){
                                        return html`<li>
                                                <strong>${msg(str`You have accepted an invite for ${invite.name} to join a subscription group.`)}</strong>
                                                <a href="${this.hardlinks.organisation_dashboard}/${org.org_id}/subscriptions/group" class="button">${msg(str`View group`)}</a>
                                            </li>`;
                                        }
                                        if(invite.inviteStatus=='Rejected'){
                                            return html`<li>
                                                <strong>${msg(str`You have declined an invite for ${invite.name} to join a subscription group`)}</strong>
                                            </li>`;
                                        }
                                        return html`<li>
                                        <strong>${msg(str`${invite.name} has been invited to join a subscription group`)}</strong>
                                        <div class="grid grid_50">
                                            <button @click=${(e)=>this._handleGroupInvite(invite.id, org.org_id,true, e)}>${msg(str`Accept invite`)}</button>
                                            <button @click=${(e)=>this._handleGroupInvite(invite.id, org.org_id,false, e)}>${msg(str`Decline invite`)}</button>
                                        </div>
                                    </li>`})}
                                </ul>
                            </div>`;
                        }
                    }
                    let progressGraph = '';
                    // if(this.orgLoaded){
                    //     progressGraph = html`
                    //         <allin-progress-graph
                    //             location="${this.hasLocation?'true':'false'}"
                    //             locationawaitingapproval="${this.isLocationApproved?'false':'true'}"
                    //             zone="${this.hasZone?'true':'false'}"
                    //             zoneawaitingapproval="${this.isZoneApproved?'false':'true'}"
                    //             approval="${this.hasApproval?'true':'false'}"
                    //         ></allin-progress-graph>
                    //     `;
                    // }
                    // else{
                    //     progressGraph = html`<allin-loader loading height="120px"></allin-loader>`;
                    // }
                    main=html`
                        <div class="grid">
                            <h2><allin-greeting username=${this.user.firstName} loggedin tabindex="0"></allin-greeting></h2>
                            ${groupInvites}
                            ${slot}
                           
                            ${notifications}
                            
                            <allin-organisation-notices notices=${this.organisation?.notices}></allin-organisation-notices>
                            <allin-location-status></allin-location-status>
                            ${progressGraph}
                            <div class="video"><slot name="onboarding-video" @slotchange=${onboarded?this._removeNode:this._addSrc}></slot></div>
                            <div class="video"><slot name="post-onboarding-video" @slotchange=${onboarded?this._addSrc:this._removeNode}></slot></div>
                            ${subscribeEl}
                            
                            ${this.hasCulturalProfile ? html`
                                <div class="links_wrapper ${onboarded ? 'onboarded' : ''} ${tier.toLowerCase()}">
                                    <slot name="links"></slot>
                                    ${!tier?html`<allin-loader loading></allin-loader>`:''}
                            </div>
                            ` : !tier?html`<allin-loader loading></allin-loader>`:''}
                            
                            ${locationsEl}
                            ${supportEl}
                        </div>
                    `;
                }
            }
        }
        else{
            let invites='';
            let groupInvites = '';
            if(this.user.invites.length > 0){
                invites  =  html`<div class="invites">
                    <h4>${msg(str`Your invites`)}</h4>
                    <ul>
                        ${this.user.invites.map((invite)=>html`<li>
                            <strong>${invite.organisationName}</strong>
                            <a href="${this.hardlinks.accept_invite}?orgId=${invite.organisationId}&email=${encodeURIComponent(invite.email)}&role=${invite.role}&invite=${invite.id}&user=${this.user.id}">${msg(str`Accept invite`)}</a>
                        </li>`)}
                    </ul>
                </div>`;
            }
            if(this.user.groupInvites.length > 0 && this.groupFlag ){
                groupInvites  =  html`<div class="invites">
                    <h4>${msg(str`Your subscription group invites`)}</h4>
                    <ul>
                        ${this.user.groupInvites.map((invite)=>{
                            let org = this.organisations.find((org)=>org.name==invite.name);
                            if(invite.inviteStatus=='Accepted'){
                            return html`<li>
                                    <strong>${msg(str`You have accepted an invite for ${invite.name} to join a subscription group.`)}</strong>
                                    <a href="${this.hardlinks.organisation_dashboard}/${org.org_id}/subscriptions/group" class="button">${msg(str`View group`)}</a>
                                </li>`;
                            }
                            if(invite.inviteStatus=='Rejected'){
                                return html`<li>
                                    <strong>${msg(str`You have declined an invite for ${invite.name} to join a subscription group`)}</strong>
                                </li>`;
                            }
                            return html`<li>
                            <strong>${msg(str`${invite.name} has been invited to join a subscription group`)}</strong>
                            <div class="grid grid_50">
                                <button @click=${(e)=>this._handleGroupInvite(invite.id, org.org_id,true, e)}>${msg(str`Accept invite`)}</button>
                                <button @click=${(e)=>this._handleGroupInvite(invite.id, org.org_id,false, e)}>${msg(str`Decline invite`)}</button>
                            </div>
                        </li>`})}
                    </ul>
                </div>`;
            }
            main = html` 
                <h2><allin-greeting username=${this.user.firstName} loggedin></allin-greeting></h2>
                <slot name="dashboard-flavour-text"></slot>
                <allin-organisation-notices notices=${this.organisation?.notices}></allin-organisation-notices>
                ${invites} 
                ${groupInvites} 
                ${Array.isArray(this.organisation) && this.organisation.length > 0
                    ? html`<h3>${msg(str`Your organisation accounts`)}</h3>`
                    : ''
                }
                <!--<p>${msg(html`Select <strong>Manage this organisation</strong> to add location profiles, team members, and view the standards.`)}</p>-->
                <ul>
                    ${this.organisations.map((organisation, index)=>{ 
                        let status = getStatus(organisation.approvalStatus);
                        let tier = getTier(organisation.subscriptionTier);
                        let declineMessage = organisation.declineMessage;
                        let profile = organisation.profiles.find((profile)=>profile.type=='cultural');
                        let supportProfile = organisation.profiles.find((profile)=>profile.type=='support');
                        if(supportProfile &&!profile){
                            tier=msg(str`Support Profile`);
                        }
                        let message = msg(str`Manage this organisation`);
                        let link = html`<a href="javascript:void(0)" class="card_target" data-profile_id="${profile?.profile_id}" data-org_id="${organisation.org_id}" @click=${this._handleOrganisationClick}>${message}</a>`;
                        if(organisation.approvalStatus=='NewApplication'){
                            message = msg(str`Complete your application`);
                            const org = this._getOrganisationById(organisation.org_id);
                            const page = org?.in_progress != null ? Math.max(0, Number(org.in_progress) - 0) : this.existingFormPage;
                            link = html`<a href="${this.hardlinks.organisation_dashboard_create_organisation}?org_id=${organisation.org_id}&&ppage=${page}" class="card_target follow">${message}</a>`;
                        }
                        let image = html`<img src="/wp-content/themes/ace/assets/OG-image.png" alt="Placeholder image" width="200" height="130">`;
                       if(organisation.fileURL) {
                            const altText = organisation.photoAltText === 'Decorative' ? '' : organisation.photoAltText;
                           image = html`<img src="${decodeURI(organisation.fileURL)}" alt="${altText}" width="200" height="130">`;
                       }
                       let notices = declineMessage?html`<div class="notices">
                                    <span class="screen-reader-text">
                                        ${declineMessage?msg(str`You have a notice relating to ${organisation.name}`):''}
                                    </span>
                                    <span aria-hidden="true" >${declineMessage?'1':''}</span>
                                </div>`:'';
                        let inlineNotices = '';
                        let hasFetchedOrgsSpinner = '';
                        if(!this._hasFetchedOrgs.includes(organisation.org_id)) {
                            hasFetchedOrgsSpinner = html`
                            <div class="has-fetched-orgs-spinner"><p class="small">${msg(str`Checking for updates`)}</p></div>
                        `;
                        }
                        if(organisation.approvalStatus=='Rejected'){
                            inlineNotices = declineMessage?html`<div class="notices">
                                <p>${declineMessage}</p>
                            </div>`:'';
                            notices = '';
                            link = '';
                        }
                        if(this.hasForm&&organisation.approvalStatus!='Approved'&&organisation.approvalStatus!='Rejected'){
                            if(organisation.org_id==this.existingForm.org_id){
                                const org = this._getOrganisationById(organisation.org_id);
                                const page = org?.in_progress != null ? Math.max(0, Number(org.in_progress) - 0) : this.existingFormPage;
                                //link = html`<a href="${this.hardlinks.organisation_dashboard_create_organisation}" class="card_target follow">${msg(str`Complete your application`)}</a>`;
                                link = html`<a href="${this.hardlinks.organisation_dashboard_create_organisation}?org_id=${organisation.org_id}&&ppage=${page}" class="card_target follow">${msg(str`Complete your application`)}</a>`;
                                if(supportProfile &&!profile){
                                    link = html`<a href="${this.hardlinks.organisation_dashboard_create_support_organisation}?org_id=${organisation.org_id}&&ppage=${page}" class="card_target follow">${msg(str`Complete your application`)}</a>`;
                                }
                            }
                        }
                        return html`
                            <li class="bg profile-card card">
                                ${hasFetchedOrgsSpinner}
                                ${image}
                                <div class="profile-content">
                                    <h4>${decodeEntities(organisation.name)}</h4>
                                    <h5>${tier} Account</h5>
                                    <p class="status small ${organisation.approvalStatus.toLowerCase()}">${status}</p>
                                    <div class="semibold"><allin-markdown-editor readonly value="${decodeEntities(profile?.description)}"></allin-markdown-editor></div>
                                    ${link}
                                    ${inlineNotices}
                                </div>
                                ${notices}
                            </li>
                        `
                    })}
                </ul>
            `
        }
        return html`${main}`;
    }

    _handleOrganisationClick(e){
        e.preventDefault();
        let id = e.target.getAttribute('data-org_id');
        //let org = this._getOrganisationById(id);
        this._switchOrg(id);
        /* if(org.declineMessage){
            this.panel = 'account';
            this._showSettings();
        } */
    }

    _switchOrg(id,dashboard=''){
        if(this.currentOrg==id&&this.dashboard==dashboard){
            return;
        }
        this.orgLoaded = false;
        this.currentOrg = id;
        this.dashboard = dashboard;
        this.panel = '';
        this.view = '';
        this.organisation = this._getOrganisationById(this.currentOrg);
        this.context = {...this.context,currentOrg:this.currentOrg,dashboard:this.dashboard,organisation:this.organisation};
        this._provider.setValue(this.context);
        window,scrollTo({top:0,behavior:'smooth'});
    }

    _emitAll(changeHistory){
        this.organisation = this._getOrganisationById(this.currentOrg);
        let orgName = this.organisation.name;
        let queryStr = this.dashboard?`/${this.currentOrg}/${this.dashboard}`:`/${this.currentOrg}`;
        this._setDocumentTitle(`${orgName} Dashboard`);
        this.eventManager.emit('allin-organisation-selected',{id:this.currentOrg});
        this.eventManager.emit(`allin-header-${this.name}`,{name:this.name,text:`${orgName} Dashboard`});
        this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:this._getNav(this.currentOrg), currentPage:`${this.hardlinks.organisation_dashboard}/${queryStr}`});
        if(!this.dashboard){
            let crumb = {organisation:{url:`${this.hardlinks.organisation_dashboard}/${this.currentOrg}`,title:msg(str`${orgName}`)}};
            this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
        }
        //this.eventManager.emit(`allin-breadcrumb-${this.name}`,{reset:'reset',crumb:{url:`/organisation-dashboard/${this.currentOrg}`,title:orgName}})
        if(changeHistory){
            this.eventManager.addHistory(`${this.hardlinks.organisation_dashboard}${queryStr}`,{currentOrg:this.currentOrg,dashboard:this.dashboard});
        }
        this.context = {...this.context,currentOrg:this.currentOrg,dashboard:this.dashboard,organisation:this.organisation};
        this._provider.setValue(this.context);
    }

    _emitReset(){
        this._setDocumentTitle('Organisation Dashboard');
        this.eventManager.emit('allin-organisation-selected',{id:''});
        this.eventManager.emit(`allin-header-${this.name}`,{name:this.name,revert:true});
        this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:this._getInitialNav(),currentPage:this.hardlinks.organisation_dashboard});
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,null);
        this.eventManager.addHistory(this.hardlinks.organisation_dashboard,{currentOrg:'',dashboard:''});
        this.organisation = null;
        this.context = {...this.context,currentOrg:this.currentOrg,dashboard:this.dashboard, organisation:this.organisation};
        this._provider.setValue(this.context);
    }

    _setDocumentTitle(title){
        document.title = `${title} - All In`;
    }

    async _emitDashboard(changeHistory,reset=false){
        let path = 'settings';
        let name = msg(str`Settings`);
        let tier = this._getTier();
        let canAccess = true;
        if(this.dashboard=='locations'){
            path = 'locations';
            name = msg(str`Manage Locations and Zones`);
        }
        else if(this.dashboard=='members'){
            path = 'members';
            name = msg(str`Members lookup`);
            if(tier!='Tier3'){
                canAccess = false;
            }
        }
        else if(this.dashboard=='events'){
            path = 'events';
            name = msg(str`Manage Events`);
            if(tier=='Tier1'||!tier){
                canAccess = false;
            }
        }  
        else if(this.dashboard=='subscriptions'){
            path = 'subscriptions';
            name = msg(str`Manage Subscriptions`);
            if(this.panel=='group'&& this._isAdmin() && this.groupFlag){
                path = 'subscriptions/group';
                name = msg(str`Manage group`);
            }
        }
        else if(this.dashboard=='integrations'){
            path = 'integrations';
            name = msg(str`Manage Integrations`);
            if(tier=='Tier1'||!tier){
                canAccess = false;
            }
        }
        else if(this.dashboard=='support'&&this.supportFlag){
            path = 'support';
            name = msg(str`Manage Support Profiles`);
        }
        if(!canAccess){
            this.dashboard = '';
            return;
        }
        let nav = document.querySelector('allin-navigation');
        let breadcrumb = document.querySelector('allin-breadcrumb');
        if(!this.organisation){
            this.organisation = this._getOrganisationById(this.currentOrg);
        }
        if(breadcrumb){
            await breadcrumb.updateComplete;
        }
        let crumb = {organisation:{url:`${this.hardlinks.organisation_dashboard}/${this.currentOrg}`,title:msg(str`${this.organisation.name}`)},dashboard:{url:`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/${path}`,title:name}};
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
        await new Promise((resolve) => requestAnimationFrame(resolve));
        if(nav){
            await nav.updateComplete;
        }
        this._setDocumentTitle(name);
        this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:this._getNav(this.currentOrg),currentPage:`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/${path}`});
        if(!this.organisation){
            this.organisation = this._getOrganisationById(this.currentOrg);
        }
        //this.eventManager.emit(`allin-breadcrumb-${this.name}`,{crumb:{url:`/organisation-dashboard/${this.currentOrg}/${path}`,title:name},back:reset?reset:false});
        if(changeHistory){
            this.eventManager.addHistory(`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/${this.dashboard}`,{dashboard:this.dashboard});
        }
        this.context = {...this.context,dashboard:this.dashboard,panel:this.panel,view:this.view};
        this._provider.setValue(this.context);
    }


    _getOrganisationById(id){
        return this.organisations.find((org)=>org.org_id==id);
    }

    _showDashboard(e=false){
        if(e){
            e.preventDefault();
        }
        this.currentOrg = '';
        this.dashboard = '';
    }

    _showMembers(e=false){
        if(e){
            e.preventDefault();
        }
        this.dashboard = 'members';
        setTimeout(()=>{
            this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:this._getNav(this.currentOrg),currentPage:`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/members`});
        },200);
        this.eventManager.addHistory(`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/members`,{dashboard:'members'});
    }

    _resetNavigation(e){
        let path = 'locations';
        if(e.detail.path){
            path = e.detail.path;
        }
        this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:this._getNav(this.currentOrg),currentPage:`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/${path}`});
    }

    _showLocations(e=false){
        if(e){
            e.preventDefault();
        }
        let panel = '';
        let view = '';
        if(this.initiating){
            panel = this.panel;
            view = this.view;
        }
        if(this.dashboard!='locations'){
            this.dashboard = 'locations';
            this.panel = panel;
            this.view = view;
        }
        else{
            this._emitDashboard(false,2);
            this.renderRoot.querySelector('allin-organisation-locations-manager')?.removeAttribute('panel');
            this.panel = panel;
            this.view = view;
        }
    }

    _showMembers(e=false){
        if(e){
            e.preventDefault();
        }
        let panel = '';
        let view = '';
        if(this.initiating){
            panel = this.panel;
            view = this.view;
        }
        if(this.dashboard!='members'){
            this.dashboard = 'members';
            this.panel = panel;
            this.view = view;
        }
        else{
            this._emitDashboard(false,2);
            this.renderRoot.querySelector('allin-organisation-members-manager')?.removeAttribute('panel');
            this.panel = panel;
            this.view = view;
        }
    }
    _showEvents(e=false){
        if(e){
            e.preventDefault();
        }
        let panel = '';
        let view = '';
        this._hasLocation();
        this._hasZone();
        this._isPilot();
        let tier = this._getTier();
        if( tier=='Tier1'){
            this.dashboard='subscriptions';
            return;
        }
        if(this.initiating){
            panel = this.panel;
            view = this.view;
        }
        if(this.dashboard!='events'){
            this.dashboard = 'events';
            this.panel = panel;
            this.view = view;
        }
        else{
            this._emitDashboard(false,2);
            this.renderRoot.querySelector('allin-organisation-events-manager')?.removeAttribute('panel');
            this.panel = panel;
            this.view = view;
        }
    }

    _showIntegrations(e=false){
       if(e){
            e.preventDefault();
        }
        let panel = '';
        let view = '';
        this._hasLocation();
        this._hasZone();
        this._isPilot();
        let tier = this._getTier();
        if(!this.hasLocation || !this.isLocationApproved || tier=='Tier1'){
            this.dashboard='integrations';
            return;
        }
         if(this.initiating){
            panel = this.panel;
            view = this.view;
        }
        if(this.dashboard!='integrations'){
            this.dashboard = 'integrations';
            this.panel = panel;
            this.view = view;
        }
        else{
            this._emitDashboard(false,2);
            this.renderRoot.querySelector('allin-organisation-integrations-manager')?.removeAttribute('panel');
            this.panel = panel;
            this.view = view;
        }
    }

    _showSettings(e=false){
        if(e){
            e.preventDefault();
        }
        if(this.dashboard!='settings'){
            this.dashboard = 'settings';
        }
        else{
            this._emitDashboard(true,2);
            this.renderRoot.querySelector('allin-organisation-settings')?.removeAttribute('panel');
        }
    }

    _showSubscriptions(e=false,group=false){
        if(e){
            e.preventDefault();
        }
        if(this.dashboard!='subscriptions'){
            this.dashboard='subscriptions';
            if(group&&this.groupFlag){
                this.panel = 'group';
                this.context = {...this.context,panel:this.panel};
                this._provider.setValue(this.context);
            }
        }
        else{
            this._emitDashboard(false,2);
            this.renderRoot.querySelector('allin-organisation-subscriptions')?.removeAttribute('panel');
        }
    }

    _showSupport(e=false){
        if(e){
            e.preventDefault();
        }
        if(this.dashboard!='support'){
            this.dashboard='support';
        }
        else{
            this._emitDashboard(false,2);
            this.renderRoot.querySelector('allin-organisation-support-profile')?.removeAttribute('panel');
        }
    }
    
    _getInitialNav(id){
        let org = this._getOrganisationById(id);
        let initialNav = [];
        let orgsNav = 
            [
                {title:msg(str`My organisation Accounts`),url:this.hardlinks.organisation_dashboard,callback:this._showSettings.bind(this),id:`organisation-dashboard`}
            ];
        if (Array.isArray(this.organisations)) {
            if(this.organisations.length==1){
                let org = this.organisations[0];
                let id = org.org_id;
                if(org?.approvalStatus){
                    let navArray = [
                        {title:decodeEntities(org.name),noTransform: true,url:`#`,id:`organisation-dashboard${id}`,callback:(e)=>{e.preventDefault();this._switchOrg(id)}},
                    // {title:msg(str`Member Lookup`),url:`/organisation-dashboard/${id}/members`,callback:this._showMembers.bind(this),icon:'lookup'},
                        
                    ];
                    
                    let tier = this._getTier(org);
                    this._hasLocation(org);
                    this._hasApproval(org);
                    this._isPilot(org);
                    this._setProfilesTypes(org);
                    if(this.isPilot){
                        navArray.push(
                            {
                                title:msg(str`Member lookup`),
                                url:`#`,
                                id:`organisation-dashboard${id}members`,
                                callback:(e)=>{
                                    e.preventDefault();
                                    this._showMembers(e);
                                }
                            }
                        );
                    }
                    if(this.hasCulturalProfile){
                        navArray.push({title:msg(str`Manage Locations and Zones`),
                            url:`#`,
                            id:`organisation-dashboard${id}locations`,
                            callback:(e)=>{
                                e.preventDefault();
                                this._switchOrg(id,'locations');
                                this._showLocations(e);
                            }
                        });
                    }
                    if(tier!='Tier1' && this.hasCulturalProfile){
                        navArray.push(
                            {
                                title:msg(str`Manage Events`),
                                url:`#`,
                                id:`organisation-dashboard${id}events`,
                                callback:(e)=>{
                                    e.preventDefault();
                                    this._switchOrg(id);
                                    this._showEvents(e);
                                }
                            }
                        );
                        navArray.push(
                            {
                                title:msg(str`Manage Integrations and APIs`),
                                url:`#`,
                                id:`organisation-dashboard${id}integrations`,
                                callback:(e)=>{
                                    e.preventDefault();
                                    this._switchOrg(id);
                                    this._showIntegrations(e);
                                }
                            }
                        ) 
                    }
                    if(this.hasCulturalProfile){
                        navArray.push(
                            {title:msg(str`Manage subscriptions`),url:`#`,id:`organisation-dashboard${id}subscriptions`,callback:(e)=>{
                                e.preventDefault();
                                this._switchOrg(id);
                                this._showSubscriptions(e);
                            }},
                        );
                        if(this.dashboard=='subscriptions'&&this._isAdmin()&&this.groupFlag){
                            navArray.push(
                                {title:msg(str`Manage group`),url:`#`,id:`organisation-dashboard${id}subscriptionsgroup`,indent:true,callback:(e)=>{
                                    e.preventDefault();
                                    this._switchOrg(id);
                                    this._showSubscriptions(e,true);
                                }},
                            );
                        }
                    }
                    if(this.supportFlag&&this.isPilot){
                        navArray.push(
                            {title:msg(str`Manage support directory listing`),url:`#`,id:`organisation-dashboard${id}support`,callback:(e)=>{
                                e.preventDefault();
                                this._switchOrg(id);
                                this._showSupport(e);
                            }},
                        );
                    }
                    navArray.push(
                        {title:msg(str`Organisation account settings`),url:`#`,id:`organisation-dashboard${id}settings`,callback:(e)=>{
                            e.preventDefault();
                            this._switchOrg(id);
                            this._showSettings(e);
                        }},
                    );
                    orgsNav = [...orgsNav,...navArray];
                }
                else{
                    orgsNav.unshift([
                        {title:msg(str`Organisation account settings`),url:`#`,id:`organisation-dashboard${id}settings`,callback:(e)=>{
                            e.preventDefault();
                            this._switchOrg(id);
                            this._showSettings(e);
                        }},
                         {title:msg(str`Your organisation is being reviewed`),url:`#`,id:`organisation-dashboard${id}pending`,callback:(e)=>{}}
                    ],);
                }
            }
            else{
                this.organisations.forEach((orgItem) => {
                    orgsNav.push(
                        {
                            title: orgItem.name,
                            noTransform: true,
                            url: '#',
                            id: `organisation-dashboard-${orgItem.org_id}`,
                            callback: this._loadOrganisation.bind(this, orgItem.org_id),
                        }
                    );
                });
            }
        }
        orgsNav.push(
            {title:msg(str`+ Add a new organisation`),url:`${this.hardlinks.organisation_dashboard_select_your_organisation_account_type}/?addnew=true`,callback:'',id:``}
        );

        initialNav.push(orgsNav);

        //more sideNav links
        initialNav.push(
            
            [
                {title:msg(str`All In Accessibility Standards`),url:`${this.hardlinks.all_in_for_the_sector_all_in_accessibility_standards}`,callback:this._redirectToStandards.bind(this),id:`standards`}
            ],
            [
                {title:msg(str`Support and Skills Development`), url:`${this.hardlinks.organisation_dashboard_support_and_skills}`,callback:null,id:'support'}
            ],
            [
                {
                  title:msg(str`Account Help Centre`), url:'https://allin.zendesk.com' 
                }
            ]
        );

        // Member link
        /* const hasMembership = !!this.user.membershipID;

        if (hasMembership) {
            initialNav.push([
                {
                    title: msg(str`Member Dashboard`),
                    url: '/dashboard',
                    id: `member-dashboard`
                }
            ]);
        } else {
            initialNav.push([
                {
                    title: msg(str`Create a member account`),
                    url: '/dashboard/create-membership/',
                    id: `create-member-account`
                }
            ]);
        } */
       
        return initialNav;
    }

    _loadOrganisation(orgId) {
        this._switchOrg(orgId);
    }

    _getNav(id){
        let org = this._getOrganisationById(id);
        let isTaster = org?.subscriptionTier === 'Tier1';
        let tier = this._getTier();
        let nav = [
            
            
            [
                {title:msg(str`Switch organisation`),url:`#`,id:`organisation-dashboard`,callback:this._showDashboard.bind(this),icon:'switch'},
            ],
            [
                {title:msg(str`All In Accessibility Standards`),url:`${this.hardlinks.all_in_for_the_sector_all_in_accessibility_standards}`,callback:this._redirectToStandards.bind(this),id:`standards`}
            ],
            [
                {title: isTaster ? msg(str`Support and Skills Development`): msg(str`Get Support From an Access Specialist`), url: isTaster ? `${this.hardlinks.organisation_dashboard_support_and_skills}` : '/get-support-from-access-specialist/',callback:null,id:'support'}
            ],
            [
                {
                  title:msg(str`Account Help Centre`), url:'https://allin.zendesk.com' 
                }
            ]
        ];
        // Member link
        /* const hasMembership = !!this.user.membershipID;

        if (hasMembership) {
            nav.push([
                {
                    title: msg(str`Member Dashboard`),
                    url: '/dashboard',
                    id: `member-dashboard`
                }
            ]);
        } else {
            nav.push([  
                {
                    title: msg(str`Create a member account`),
                    url: '/dashboard/create-membership/',
                    id: `create-member-account`
                }
            ]);
        } */
        if(this.hasApproval){
            let navArray = [
                {title:decodeEntities(org.name),noTransform: true,url:`#`,id:`organisation-dashboard${id}`,callback:(e)=>{e.preventDefault();this._switchOrg(id)}},
               // {title:msg(str`Member Lookup`),url:`/organisation-dashboard/${id}/members`,callback:this._showMembers.bind(this),icon:'lookup'},
                
            ];
            if(this.isPilot && tier=='Tier3'){
                navArray.push(
                    {
                        title:msg(str`Member lookup`),
                        url:`#`,
                        id:`organisation-dashboard${id}members`,
                        callback:(e)=>{
                            e.preventDefault();
                            this._showMembers(e);
                        }
                    }
                );
            }

            if(this.hasCulturalProfile){
                navArray.push({title:msg(str`Manage Locations and Zones`),
                    url:`#`,
                    id:`organisation-dashboard${id}locations`,
                    callback:(e)=>{
                        e.preventDefault();
                        this._showLocations(e);
                    }
                },);
            }
            
            if( tier!='Tier1' && this.hasCulturalProfile){
                navArray.push(
                    {
                        title:msg(str`Manage Events`),
                        url:`#`,
                        id:`organisation-dashboard${id}events`,
                        callback:(e)=>{
                            e.preventDefault();
                            this._showEvents(e);
                        }
                    }
                );
                navArray.push(
                    {
                        title:msg(str`Manage Integrations and APIs`),
                        url:`#`,
                        id:`organisation-dashboard${id}integrations`,
                        callback:(e)=>{
                            e.preventDefault();
                            this._showIntegrations(e);
                        }
                    }
                ) 
            }
            if(this.hasCulturalProfile){
                navArray.push(
                    {title:msg(str`Manage subscriptions`),url:`#`,id:`organisation-dashboard${id}subscriptions`,callback:(e)=>{
                        e.preventDefault();
                        this._switchOrg(id);
                        this._showSubscriptions(e);
                    }},
                );
                if(this.dashboard=='subscriptions'&&this._isAdmin()&&this.groupFlag){
                    navArray.push(
                        {title:msg(str`Manage group`),url:`#`,id:`organisation-dashboard${id}subscriptionsgroup`,indent:true,callback:(e)=>{
                            e.preventDefault();
                            this._switchOrg(id);
                            this._showSubscriptions(e,true);
                        }},
                    );
                }
            }
            if(this.supportFlag&&this.isPilot){
                navArray.push(
                    {title:msg(str`Manage support directory listing`),url:`#`,id:`organisation-dashboard${id}support`,callback:(e)=>{
                        e.preventDefault();
                        this._switchOrg(id);
                        this._showSupport(e);
                        }
                    },
                );
            }
            navArray.push(
                {title:msg(str`Organisation account settings`),url:`#`,id:`organisation-dashboard${id}settings`,callback:this._showSettings.bind(this)},
            );
            nav.unshift(navArray);
        }
        else{
            nav.unshift([
                {title:msg(str`Organisation account settings`),url:`#`,id:`organisation-dashboard${id}settings`,callback:this._showSettings.bind(this)},
                {title:msg(str`Your organisation is being reviewed`),url:`#`,id:`organisation-dashboard${id}pending`,callback:(e)=>{}}
            ],);
        }
        return nav;
    }

    _handleUpdate(e){
        if(e.detail.organisation){
            //check if detail is a string
            if(typeof e.detail.organisation === 'string'){
                e.detail.organisation = JSON.parse(e.detail.organisation);
            }
            let orgDetail = e.detail.organisation;
            let org = this._getOrganisationById(orgDetail.org_id);
            org = {...org,...orgDetail};
            let index = this.organisations.findIndex((_org)=>_org.org_id==org.org_id);
            this.organisations[index] = org;
            this.context = {...this.context, organisations:this.organisations};
            this._provider.setValue(this.context);
            this.orgLoaded = true;
            this._hasLocation();
            this._hasZone();
            this._hasApproval();
            this._setSlotLinkClasses();
        }
        if(e.detail.provisions!=null){
            let provisions= JSON.parse(e.detail.provisions);
            this.context = {...this.context,provisions:provisions};
            this._provider.setValue(this.context);
        }
        if(e.detail.panel!=null){
            this.panel = e.detail.panel;
            this.context = {...this.context,panel:this.panel};
            this._provider.setValue(this.context);
        }
        if(e.detail.zoneProvisions!=null){
            let zoneProvisions= JSON.parse(e.detail.zoneProvisions);
            this.context = {...this.context,zoneProvisions:zoneProvisions};
            this._provider.setValue(this.context);
        }
        if(e.detail.eventProvisions!=null){
            let eventProvisions= JSON.parse(e.detail.eventProvisions);
            this.context = {...this.context,eventProvisions:eventProvisions};
            this._provider.setValue(this.context);
        }
        if(e.detail.memberProvisions!=null){
            let memberProvisions= JSON.parse(e.detail.memberProvisions);
            this.context = {...this.context,memberProvisions:memberProvisions};
            this._provider.setValue(this.context);
        }
        if(e.detail.dashboard!=null){
            let dash = e.detail.dashboard.charAt(0).toUpperCase() + e.detail.dashboard.slice(1);
            if(typeof this[`_show${dash}`] !== 'function') return;
            this[`_show${dash}`]();
            if(e.detail.panel){
                this.panel = e.detail.panel;
                if(e.detail.view){
                    this.view = e.detail.view;
                    this.context = {...this.context,panel:e.detail.panel,view:e.detail.view};
                }
                else{
                    this.context = {...this.context,panel:e.detail.panel};
                }
            }
            this._provider.setValue(this.context);
        }
        if(e.detail.location!=null){
            this.location = e.detail.location;
            this.context = {...this.context,location:this.location};
            this._provider.setValue(this.context);
        }
        if(e.detail.providerConfig!=null){
            this.providerConfig = e.detail.providerConfig;
            this.context = {...this.context,providerConfig:this.providerConfig};
            this._provider.setValue(this.context);
        }
        if(e.detail.providerConfigMapping!=null){
           this.providerConfigMapping = e.detail.providerConfigMapping;
            this.context = {...this.context,providerConfigMapping:this.providerConfigMapping};
            this._provider.setValue(this.context);
        }

        if(e.detail.members!=null){
            this.members = e.detail.members;
            this.context = {...this.context,members:this.members};
            this._provider.setValue(this.context);
        }
        if(e.detail.membersLookedUp!=null){
            this.membersLookedUp = e.detail.membersLookedUp;
            this.context = {...this.context,membersLookedUp:this.membersLookedUp};
            this._provider.setValue(this.context);
        }

    }
    _handleSwitch(e){
        if(e.detail.dashboard){
            let dash = e.detail.dashboard.charAt(0).toUpperCase() + e.detail.dashboard.slice(1);
            if(typeof this[`_show${dash}`] !== 'function') return;
            this[`_show${dash}`]();
            if(e.detail.panel){
                this.panel = e.detail.panel;
                if(e.detail.view){
                    this.view = e.detail.view;
                    this.context = {...this.context,panel:e.detail.panel,view:e.detail.view};
                }
                else{
                    this.context = {...this.context,panel:e.detail.panel};
                }
            }
            this._provider.setValue(this.context);
           
        }
    }

    _processSlot(e){
        if(!this.currentOrg){
            return;
        }
        const childNodes = e.target.assignedNodes({flatten: true});
        if(childNodes.length>0){
            let orgName = this._getOrganisationById(this.currentOrg).name;
            orgName = decodeEntities(orgName);
            childNodes.forEach((node)=>{
                let children = node.children;
                if(children&&children.length>0){
                    // If the node has children, iterate through them
                    children = Array.from(children);
                    children.forEach((child)=>{
                        const text = child.textContent;
                        if(text&&text.includes('{organisation}')){
                            child.textContent = text.replaceAll('{organisation}',orgName);
                        }
                        if(text&&text.includes('{sefydliad}')){
                            child.textContent = text.replaceAll('{sefydliad}',orgName);
                        }
                    })
                }
                else{
                    const text = node.textContent;
                    if(text&&text.includes('{organisation}')){
                        node.textContent = text.replaceAll('{organisation}',orgName);
                    }
                }
            });
        }
    }

    _addSrc(e){
        const childNodes = e.target.assignedNodes({flatten: true});
        if(childNodes.length>0){
            childNodes.forEach((node)=>{
                node.querySelectorAll('[data-src]')?.forEach((el)=>{
                    el.src = el.getAttribute('data-src');
                });
            });
        }
    }

    _removeNode(e){
        const childNodes = e.target.assignedNodes({flatten: true});
        if(childNodes.length>0){
            childNodes.forEach((node)=>{
                node.remove();
            });
        }
    }
    
    _hasLocation(org = false){
        if(!org){
            org = this._getOrganisationById(this.currentOrg);
        }
        if(org&&org?.locations?.length){
            this.hasLocation = true;
            let hasApproved = org.locations.filter((location)=>location?.location_data?.approvalStatus=='Approved');
            this.isLocationApproved = hasApproved.length>0;
        }   
        else{
            this.hasLocation = false;
            this.isLocationApproved = false;
        }
    }

    _hasZone(org = false){
        if(!org){
            org = this._getOrganisationById(this.currentOrg);
        }

        if(org&&org?.locations?.length){
            let hasZone = org.locations.filter((location)=>location.location_data?.zones&&location.location_data.zones.length>0);
            this.hasZone = hasZone.length>0;
            let hasApproved = hasZone.filter((location)=>location.location_data.zones.filter((zone)=>zone?.approvalStatus=='Approved').length>0);
            this.isZoneApproved = hasApproved.length>0;
        }
        else{
            this.hasZone = false;
            this.isZoneApproved = false;
        }
    }

    async _getUsers(org){
        
        if(!org){
            org = this._getOrganisationById(this.currentOrg);
        }
        if(!org?.users){
            this._maybeGetUsersFromLocalStorage(org);
            if(!org?.users){
                await this._fetchUsers();
            }
        }
        this.context = {...this.context,organisation:org};
        this._provider.setValue(this.context);
    }

    async _fetchUsers(){
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-users&nonce=${this.nonce}`;
        let response = await fetch(url,{
            headers: {
                'AllIn-Nonce': this.nonce,
            }
        });

        if(response.status === 403){
            handle403s();
            return;
        }

        response = await response.json();
        this._loading = false;
        let orgIndex = this.organisations.findIndex((org)=>org.org_id==this.currentOrg);
        
        this.organisations[orgIndex].users = response.users;
        this.context = {...this.context,organisations:this.organisations};
        this._provider.setValue(this.context);
        this._setUsersToSessionStorage();
        //this.eventManager.emit(`allin-organisation-${this.name}-update`,{organisation:JSON.stringify(this.organisation)});
    }

    _setSlotLinkClasses(){
        let slots = this._slottedLinkChildren;
        if(!slots||!slots.length) return;
        slots = slots[0];
        let child = slots.firstElementChild;
        if(!child) return;
        child.classList.remove('onboarded','tier1','tier2','tier3');
        //let onboarded = this._isOnboarded();
        //Changing this to just check approval
        let onboarded = this._hasApproval();
        onboarded = onboarded?'onboarded':'';
        const tier = this._getTier();
        if(onboarded){
            child.classList.add(onboarded);
        }
        if(tier){
            child.classList.add(tier.toLowerCase());
        }
    }

     _fetchAllOrganisations(){
         // Fetch organisations from the server
         let url = `${this.restUrl}?action=get_user_organisations&nonce=${this.nonce}`;
         fetch(url,{
                 headers: {
                     'AllIn-Nonce': this.nonce,
                 }
             })
             //.then(response => response.json())
             .then(response => {
                 if (response.status === 403) {
                    handle403s();
                    throw new Error(`Server returned ${response.status}`);
                }

                if (!response.ok) {
                     throw new Error(`Server returned ${response.status}`);
                 }
                 return response.json();
             })
             .then(data => {
                 data = data.sort((a,b)=>a.name.localeCompare(b.name));
                 this.organisations = data;
                 this.context = {...this.context, organisations:this.organisations};
                 this._provider.setValue(this.context);
             })
             .catch(error => {
                 console.error('Error fetching organisations:', error);
                 this._hasFetchedOrgs = [];
             });
    }

    async _fetchOrganisations() {

        if (this._fetchingOrgsComplete) {
            return;
        }

        this._fetchingOrgsComplete = true;

        try {

            const idsResponse = await fetch(
                `${this.restUrl}?action=get_user_organisation_ids&nonce=${this.nonce}`,
                {
                    headers: {
                        'AllIn-Nonce': this.nonce
                    }
                }
            );

            if (!idsResponse.ok) {
                throw new Error(`Server returned ${idsResponse.status}`);
            }

            const orgIds = await idsResponse.json();

            const organisations = [];

            for (const orgId of orgIds) {

                const response = await fetch(
                    `${this.restUrl}?action=get_user_organisation&org_id=${orgId}&nonce=${this.nonce}`,
                    {
                        headers: {
                            'AllIn-Nonce': this.nonce
                        }
                    }
                );

                if (!response.ok) {
                    console.error(`Failed loading organisation ${orgId}`);
                    continue;
                }

                let data = await response.json();

                organisations.push(
                    data
                );
                this._hasFetchedOrgs=[...this._hasFetchedOrgs, orgId];
                //find the org array key by org id
                const key = this.organisations.findIndex(
                    organisation => organisation.org_id === orgId
                );

                if(key !== -1) {
                    this.organisations[key] = data;
                    this.organisations = [...this.organisations];

                    this.context = {
                        ...this.context,
                        organisations:this.organisations
                    };

                    this._provider.setValue(this.context);
                }

            }

            // organisations.sort(
            //     (a, b) => a.name.localeCompare(b.name)
            // );

            // this.organisations = organisations;

            // this.context = {
            //     ...this.context,
            //     organisations
            // };

            this._provider.setValue(this.context);

        }
        catch (error) {

            console.error(
                'Error fetching organisations:',
                error
            );
        }
        this._fetchAllOrganisations();

    }

    _redirectToStandards() {
        // Redirect to the standards page
        window.location.href = '/all-in-for-the-sector/all-in-accessibility-standards/';
    }

    _loadNavigation(){
        let nav = this.currentOrg?this._getNav(this.currentOrg):this._getInitialNav();
        if(document.readyState === "loading"){
            document.addEventListener("DOMContentLoaded",()=>{
                let queryStr = this.currentOrg?`/${this.currentOrg}/${this.dashboard}`:'';
                this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:nav, initial:true,currentPage:`/organisation-dashboard${queryStr}`});
            })
        }
        else{
            let queryStr = this.currentOrg?`/${this.currentOrg}/${this.dashboard}`:'';
            this.eventManager.emit(`allin-navigation-${this.name}`,{navigation:nav, initial:true,currentPage:`/organisation-dashboard${queryStr}`});
        }
    }

    _handleCompleteApplication(e) {
        e.preventDefault();

        // Read IDs from the clicked link's data attributes
        const orgId = e.currentTarget.getAttribute('data-org_id');
        const profileId = e.currentTarget.getAttribute('data-profile_id');

        // Bring up the application form for this organisation
        // this._showApplicationForm(orgId, profileId);// Find the correct function to call here.
        
        this._switchOrg(id); // JUST NEEDS TO CALL THE RIGHT FUNCTION HERE OR USE THE FUNCTION OF THE WORKING LINKS
    }

    async _handleGroupInvite(inviteId, orgId, accept, e) {
        e.preventDefault();
        const button = e.currentTarget;
        button.disabled = true; // Disable the button to prevent multiple clicks
        button.classList.add('loading'); // Optionally add a loading class for styling
        let url = `${this.restUrl}`;
        try{
            let response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                },
                body: JSON.stringify({ 
                    invite_id:inviteId, 
                    status:accept?'Accepted':'Rejected', 
                    org_id:orgId,
                    action:`${this.action}-handle-group-invite` 
                }),
            });

            if(response.status === 403){
                handle403s();
                return;
            }

            if (!response.ok) {
                throw new Error(`Server returned ${response.status}`);
            }
            let data = await response.json();
            if(data.ok){
                // Handle the response data
                let groupInvite = this.user.groupInvites.findIndex(invite => invite.id === inviteId);
                if (groupInvite !== -1) {
                    this.user.groupInvites[groupInvite].inviteStatus = data.status;
                }
                this.user = {...this.user};
                this.context = {...this.context,user:this.user};
                this._provider.setValue(this.context);
            }
            else{
                console.error('Error handling group invite:', data.error);
            }
        }
        catch(error) {
            console.error('Error handling group invite:', error);
        }
        button.disabled = false;
        button.classList.remove('loading');
    }

    static styles = [
        accessibility,
        formStyles,
        markdown,
        css`
        allin-greeting{
            --allin-font-size: 1.5rem;
            --allin-font-weight: 700;
        }
        h2:has(> allin-greeting):not(:has(> :not(allin-greeting))) {
            margin: 0;
        }
        h3{
            margin-top:0;
            color:var(--allin-heading-color,#000);
        }

        h4{
            margin:0.5rem 0;
            font-size:1rem;
        }
        
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg.profile-card {
            position: relative;
        }
        .has-fetched-orgs-spinner {
            position: absolute;
            top: 0.5rem;
            right: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
        .has-fetched-orgs-spinner p {
            margin:0;
        }
        .has-fetched-orgs-spinner::after {
            content:'';
            display:block;
            width: 2rem;
            height: 2rem;
            animation: spin 1s linear infinite;
            z-index: 100;
            background-image: url(/wp-content/themes/ace/assets/wheel.svg);
            background-size: cover;
        }
        @keyframes spin {
            from {transform: rotate(0deg);}
            to {transform: rotate(360deg);}
        }
        .small{
            font-size:0.875rem;
        }

        .message{
            margin-bottom:0.5rem;
        }
        .semibold{
            font-weight:600;
        }
      
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        ul li{
            display:grid;
            gap:0.5rem;
            margin-bottom:1.5rem;
        }

        ul li img{
            object-fit:contain;
        }
        ul li a, .support-profile a{
            display:block;
            padding:0.5rem;
            color:var(--allin-button-color,#472961);
            background-color:var(--allin-button-bg-color,#fff);
            text-decoration:none;
            border:1px solid var(--allin-button-color,#472961);
            border-radius:var(--allin-border-radius,0.25rem);
            transition:background-color var(--transition) ease;
            width:fit-content;
            font-weight:700;
        }
        ul li a:hover, .support-profile a:hover{
            background-color:var(--allin-button-hover-bg-color,#472961);
            color:var(--allin-button-hover-color,#fff);
        }

        .content{
            display:grid;
            grid-template-columns:auto 1fr;
            gap:0.5rem;
        }
        .content .message{
            justify-self:end;
        }
        .content .semibold, .content a{
            grid-column:1/-1;
            word-break: break-word;
        }
        .content a{
            height:fit-content;
            align-self:end;
        }
        .button{
            margin-top:1rem;
            width:100%;
            display: block;
            text-align: center;
            box-sizing:border-box;
        }

        ul li h5{
            margin:0 0 1rem;
        }
        @media (min-width: 600px){
            ul li{
                grid-template-columns:200px 1fr 1.5rem;
                gap:2rem
            }
            ul li h4{
                margin-top:0;
            }
           
        }
        .grid{
            display:grid;
            gap:1rem;
        }
        .grid allin-greeting{
            --allin-margin:0 0 0.5rem 0;
        }

        :not(:defined) {
	        display: none;
        }

        .notices span{
            background-color: var(--allin-button-bg-color,#fff);
            color:var(--allin-button-color,#472961);
            border: 1px solid var(--allin-button-color,#472961);
            border-radius:50%;
            display:flex;
            align-items:center;
            justify-content: center;
            padding:0 0.75rem;
        }
       
       .message{
            background-color: var(--allin-button-bg-color,#fff);
            border: 1px solid var(--allin-button-color,#472961);
            padding:1rem;
            margin-bottom:1rem;
        }

        .message ul{
            list-style:disc;
            padding-left:1rem;
            margin:0;
        }

        .message ul li{
            display:list-item;
        }

        .message ul li div{
            grid-template-columns: 1fr 15ch;
            display:grid;
        }

        .message ul li a{
            color: var(--allin-button-color,#472961);
            text-decoration: underline;
            padding:0;
            border:none;
            background:transparent;
        }

        p.org-flavour-text{
            margin-bottom: 2rem;
        }
        
        .invites ul li{
            background-color: var(--color-grey);
            padding: 2rem;
            display:block;
            strong{
                margin-bottom:1rem;
                display:block;
            }
            button.loading{
                opacity:0.6;
                pointer-events:none;
            }
        }

        `
        ];


}